import React from "react";
import { $t } from './i18n';

export default ({ message }) => {
  return message ? (
    <section id="submission" className="white">
      <div className="content">
        <h2 className="section-title">{$t(message.title)}</h2>
        <div className="proposal paragraph">
          {
            message.content.desc.map(item => <p className="desc" key={item}>{$t(item)}</p>)
          }
          {
            (message.content.list || []).map(item => <p className="item" key={item}>{$t(item)}</p>)
          }
        </div>
        <div className="formate paragraph">
          <p className="desc">{$t(message.formate.desc)}</p>
          {
            (message.formate.list || []).map(item => <p className="item" key={item}>{$t(item)}</p>)
          }
        </div>
        <div className="shortlisted paragraph">
          <p className="desc">{$t(message.shortlisted.desc)}</p>
          {
            (message.shortlisted.list || []).map(item => <p className="item" key={item}>{$t(item)}</p>)
          }
        </div>
        <p className="explain">{$t(message.explain)}</p>
      </div>
    </section>
  ) : null
};
